/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MotorThermalLimits } from './MotorThermalLimits';
import type { SubmittedJob } from './SubmittedJob';
import type { ThermalModelDetails } from './ThermalModelDetails';
/**
 * Motor Lab with the data referenced by ID.
 */
export type MotorLabID = {
    item_type?: MotorLabID.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    _id?: string;
    data_id?: (string | null);
    submitted_job?: (SubmittedJob | null);
    thermal_model_details?: ThermalModelDetails;
    max_speed: number;
    flow_rate?: number;
    stator_winding_temp?: (number | null);
    rotor_temp?: (number | null);
    stator_current_limit?: (number | null);
    control_strategy_bpm?: (number | null);
    control_strategy_sync?: (number | null);
    thermal_limits?: MotorThermalLimits;
    component_type?: 'MotorLabID';
};
export namespace MotorLabID {
    export enum item_type {
        COMPONENT = 'component',
    }
}

